module.exports = __webpack_public_path__ + "img/lg_ring_r_l_0_0@2x.d0f2cf85.png";